import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useSearchParams, useNavigate } from "react-router-dom";
import { verifyTenantEmailByTokenAction } from "../../../actions/tenantRegisterActions";
import { TENANTREGISTER_VERIFY_EMAIL_BYTOKEN_RESET } from "../../../constants/tenantRegisterConstants";
import { Box, Text, Spinner } from "@chakra-ui/react";
import { primaryAlt } from "../../../utils/colors";
import { useTranslation } from "react-i18next";

const VerifyEmailPage = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const token = searchParams.get("token");
  const { t } = useTranslation();

  const {
    loading,
    success,
    token: userToken,

    error,
  } = useSelector((state) => state.tenantRegisterVerifyEmailByToken);

  useEffect(() => {
    if (token) {
      dispatch(verifyTenantEmailByTokenAction(token));
    }
  }, [dispatch, token]);

  //   useEffect(() => {
  //     if (success && userToken) {
  //       // Store token in localStorage or dispatch login
  //       localStorage.setItem("authToken", userToken);
  //       // Navigate to tenant dashboard
  //       navigate("/select-tenant");
  //     }
  //   }, [success, userToken, navigate]);

  return (
    <Box
      w="100%"
      h="100vh"
      display="flex"
      flexDirection="column"
      alignItems="center"
      justifyContent="center"
    >
      {loading && (
        <Box>
          <Text
            color="red.500"
            fontWeight="500"
            fontSize="1.125rem"
            textAlign="center"
            m="0 0 1.5rem"
          >
            {t("common.verifyTokenLoading")}
          </Text>
          <Spinner color={primaryAlt} size="lg" />
        </Box>
      )}
      {error && (
        <Box>
          <Text
            color="red.500"
            fontWeight="500"
            fontSize="1.5rem"
            textAlign="center"
          >
            {t("common.verifyTokenExpiredError")}
          </Text>
        </Box>
      )}
      {!loading && !success && (
        <Box m="1.5rem 0 0">
          <Spinner color={primaryAlt} size="lg" />
        </Box>
      )}
    </Box>
  );
};

export default VerifyEmailPage;
